// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    font-family: "Quicksand", sans-serif;
}
body {
    margin: 0;
    /* t */
    background-color: #fff;
    font-family: "Quicksand", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
        monospace;
}

.spinner {
    height: 100vh;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.loader {
    color: red;
    /* background-color: red; */
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

@media print {
    .print-source {
        display: none;
    }
}

.gradient-text {
    color: #eb5d27;
    background-color: #f3ec78;
}

.ant-cascader-menu {
    /* min-height: 50px; */
    height: auto;
}
.ant-checkbox-group-item {
    display: block;
    margin-right: 0;
    margin-bottom: 10px;
}

.ant-table table {
    font-size: 13px;
    padding: 0 !important;
}
.ant-table tr {
    padding: 0;
}

.ant-table thead > tr > th {
    /* background-color: #1e86c1 !important; */
    background-color: #00536d !important;
    padding: 0.5em !important;
    color: #fff !important;
}

.ant-checkbox-inner {
    width: 18px;
    height: 18px;
}

.menu-avatar {
    border-style: solid;
    border-width: 4px;
    border-image: linear-gradient(to top, #c9d6ff, #e2e2e2) 1;
}

.grey {
    color: grey;
}

.font13 {
    font-size: 13px;
}

.pointer {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;IACI,oCAAoC;AACxC;AACA;IACI,SAAS;IACT,MAAM;IACN,sBAAsB;IACtB,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI;iBACa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,oCAAoC;IACpC,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,yDAAyD;AAC7D;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap\");\nhtml {\n    font-family: \"Quicksand\", sans-serif;\n}\nbody {\n    margin: 0;\n    /* t */\n    background-color: #fff;\n    font-family: \"Quicksand\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n        monospace;\n}\n\n.spinner {\n    height: 100vh;\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n.loader {\n    color: red;\n    /* background-color: red; */\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n@media print {\n    .print-source {\n        display: none;\n    }\n}\n\n.gradient-text {\n    color: #eb5d27;\n    background-color: #f3ec78;\n}\n\n.ant-cascader-menu {\n    /* min-height: 50px; */\n    height: auto;\n}\n.ant-checkbox-group-item {\n    display: block;\n    margin-right: 0;\n    margin-bottom: 10px;\n}\n\n.ant-table table {\n    font-size: 13px;\n    padding: 0 !important;\n}\n.ant-table tr {\n    padding: 0;\n}\n\n.ant-table thead > tr > th {\n    /* background-color: #1e86c1 !important; */\n    background-color: #00536d !important;\n    padding: 0.5em !important;\n    color: #fff !important;\n}\n\n.ant-checkbox-inner {\n    width: 18px;\n    height: 18px;\n}\n\n.menu-avatar {\n    border-style: solid;\n    border-width: 4px;\n    border-image: linear-gradient(to top, #c9d6ff, #e2e2e2) 1;\n}\n\n.grey {\n    color: grey;\n}\n\n.font13 {\n    font-size: 13px;\n}\n\n.pointer {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
